import { Backdrop, CircularProgress } from "@material-ui/core";
import { boolean } from "yup";

interface IAppLoader {
  open: boolean;
}

const AppLoader = ({ open }: IAppLoader) => (
  <Backdrop
    sx={{
      color: "#fff",
      zIndex: 2000,
    }}
    style={{
      zIndex: 2000,
    }}
    open={open}>
    <CircularProgress color="primary" />
  </Backdrop>
);

export default AppLoader;
